export default "__VITE_ASSET__BYkfgOSP__"